<template>
  <div>
    <base-button class="discount-alert" @click="handleAlertClick">
      <div>
        <span
          >Now Available: <strong>Professional Design Services</strong></span
        >
        <i class="fas fa-external-link-alt"></i>
      </div>
    </base-button>
    <!-- <div v-if="isInstagram" class="discount-alert"></div> -->
    <!-- NAVIGATION -->
    <base-nav
      v-model="showMenu"
      type="light"
      :transparent="true"
      menu-classes="justify-content-end"
      :class="headerClasses"
      expand="lg"
    >
      <div slot="brand" class="mr-3">
        <router-link to="/">
          <img
            src="/img/brand/artgrab-logo-white.png"
            alt="Art Grab"
            fetchPriority="high"
            width="120"
            height="40"
          />
        </router-link>
      </div>

      <template>
        <div class="navbar-collapse-header">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img src="/img/brand/artgrab-logo.png" alt="Art Grab" />
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <button
                type="button"
                class="navbar-toggler"
                @click="showMenu = false"
                aria-label="Toggle navigation"
              >
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>

        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <router-link
              to="/store"
              @click.native="resetSearch"
              class="nav-link"
            >
              <span class="nav-link-inner--text">Shop</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/sell" class="nav-link">
              <span class="nav-link-inner--text">Sell</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/artists" class="nav-link">
              <span class="nav-link-inner--text">Artists</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/about" class="nav-link">
              <span class="nav-link-inner--text">About</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/blog" class="nav-link">
              <span class="nav-link-inner--text">Blog</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/latest" class="nav-link">
              <span class="nav-link-inner--text">Latest</span>
            </router-link>
          </li>
        </ul>
        <ul class="navbar-nav align-items-lg-center ml-lg-auto">
          <div class="nav-action-wrapper d-none d-lg-block">
            <router-link
              to="/store"
              aria-label="Search for artwork in the store"
            >
              <i class="fa fa-search search-icon" />
            </router-link>
            <router-link v-if="isLoggedIn" to="/mycollections">
              <i class="fa fa-heart search-icon" />
            </router-link>
            <!-- <router-link
              v-if="isLoggedIn"
              class="notification-button"
              to="/notifications"
            >
              <i class="fas fa-bell search-icon" />
              <span
                v-if="unreadNotifications > 0"
                class="badge badge-sm badge-circle bg-red text-white notification-badge"
                >{{ unreadNotifications }}</span
              >
            </router-link> -->
            <button class="cart-button" @click="handleCartClick">
              <i class="fa-solid fa-cart-shopping cart-icon"></i>
              <span
                v-if="stripe.cartItems.length > 0"
                class="badge badge-sm badge-circle bg-red text-white notification-badge"
                >{{ cartCount }}</span
              >
            </button>
          </div>
          <li v-if="isLoggedIn" class="nav-item ml-lg-2">
            <router-link class="nav-link" to="/memberdashboard">
              <span class="nav-link-inner--text">Dashboard</span>
            </router-link>
          </li>
          <li v-if="user.exclusiveCreditCount > 0" class="nav-item">
            <div class="nav-link credits-link">
              <span class="nav-link-inner--text">
                CREDITS:
                <strong>{{ user.exclusiveCreditCount }}</strong>
              </span>
            </div>
          </li>
          <li v-if="!isLoggedIn" class="nav-item ml-lg-2">
            <router-link
              to="/login"
              class="btn btn-outline-secondary btn-sm login-button"
            >
              <span class="nav-link-inner--text">CUSTOMER LOGIN</span>
            </router-link>
          </li>
          <li v-if="!isLoggedIn" class="nav-item ml-lg-2">
            <a
              :href="portalUrl"
              class="btn btn-outline-secondary btn-sm login-button"
            >
              <span class="nav-link-inner--text">ARTIST LOGIN</span>
            </a>
          </li>
          <li v-if="isLoggedIn" class="nav-item ml-lg-2">
            <base-button
              class="login-button"
              block
              size="sm"
              type="outline-secondary"
              @click="logout"
              >LOG OUT</base-button
            >
          </li>
        </ul>
      </template>
    </base-nav>

    <!-- PAGE CONTENT -->
    <div id="auth-layout" class="main-content">
      <fade-transition
        :duration="pageTransitionDuration"
        mode="out-in"
        @after-leave="$root.$emit('triggerScroll')"
      >
        <router-view></router-view>
      </fade-transition>
    </div>

    <!-- FOOTER -->
    <site-footer v-if="showFooter" />

    <!-- MODALS -->
    <claim-image />
    <add-to-collection />
    <create-collection />
    <edit-collection />
    <previews-modal />
    <login-modal />
    <typography-services-modal
      v-if="typographyServices.length"
      :options="typographyServices"
      @serviceSelected="addService"
    />
    <cart-modal />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { BaseNav } from "@/components";
import { FadeTransition } from "vue2-transitions";
import {
  SiteFooter,
  ClaimImage,
  AddToCollection,
  CreateCollection,
  EditCollection,
  LoginModal,
  PreviewsModal,
  CartModal,
} from "../../components";
import TypographyServicesModal from "../../components/TypographyServicesModal.vue";
const apiBaseURL = process.env.VUE_APP_API_URL;

export default {
  components: {
    BaseNav,
    FadeTransition,
    SiteFooter,
    ClaimImage,
    AddToCollection,
    CreateCollection,
    EditCollection,
    LoginModal,
    PreviewsModal,
    CartModal,
    TypographyServicesModal,
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black",
    },
  },
  metaInfo() {
    return {
      meta: [{ vmid: "og:type", property: "og:type", content: "website" }],
    };
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 100,
      year: new Date().getFullYear(),
      pageClass: "login-page",
      noHeaderPages: [
        "Member Dashboard",
        "My Images",
        "Terms of Service",
        "Not Found",
        "Image Product",
        "Animation Product",
        "My Collections",
        "Collection",
        "Artist Agreement",
        "Latest",
        "Store",
        "Notifications",
        "Privacy Policy",
        "Email Preferences",
        "Checkout",
      ],
      scrolled: false,
      modals: {
        claimImage: false,
        addToCollection: false,
        createCollection: false,
        editCollection: false,
        cart: false,
      },
      isInstagram: false,
      // notificationLoop: null,
      typographyServices: [],
    };
  },
  computed: {
    // ...mapState([
    //   "isLoggedIn",
    //   "user",
    //   "referral",
    //   "showAddToCollectionModal",
    //   "showCreateCollectionModal",
    //   "showEditCollectionModal",
    //   "notifications",
    // ]),
    ...mapState([
      "isLoggedIn",
      "user",
      "referral",
      "showAddToCollectionModal",
      "showCreateCollectionModal",
      "showEditCollectionModal",
      "stripe",
      "lastAddedToCart",
    ]),
    cartCount() {
      const designCount = this.stripe.cartItems.filter(
        (i) => !!i.design_service
      ).length;
      const designOnlyCount = this.stripe.cartItems.filter(
        (i) => !!i.is_design_service_only
      ).length;
      return this.stripe.cartItems.length + designCount - designOnlyCount;
    },
    title() {
      return `${this.$route.name} Page`;
    },
    portalUrl() {
      let portalUrl = process.env.VUE_APP_PORTAL_URL;
      if (this.referral) {
        portalUrl += "?referral=" + this.referral;
      }
      return portalUrl;
    },
    headerClasses() {
      let classes = "navbar-horizontal navbar-main";

      if (this.isInstagram) {
        classes += " instagram-nav";
      }

      if (this.noHeaderPages.includes(this.$route.name) || this.scrolled) {
        classes += " navbar-black";
      }

      return classes;
    },
    showFooter() {
      return !["Store"].includes(this.$route.name);
    },
    // unreadNotifications() {
    //   const count = this.notifications.filter(
    //     (notification) => notification.status === "unread"
    //   ).length;

    //   return count > 99 ? 99 : count;
    // },
  },
  methods: {
    addService(value) {
      const service = this.typographyServices.find((t) => t.name === value);
      if (service && this.lastAddedToCart) {
        this.axios
          .post(`${apiBaseURL}/api/artv1.1/user/adddesignservice`, {
            artwork_id: this.lastAddedToCart.id,
            type: this.lastAddedToCart.type,
            thumbnail: this.lastAddedToCart.thumbnail,
            artist: this.lastAddedToCart.artist,
            design_service: service.sku,
          })
          .then((result) => {
            if (result.data.data.message === "Success") {
              this.$store.dispatch("getCart");
            }
          })
          .catch((error) => {
            /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
            console.error(error);
          });
      }
    },
    handleCartClick() {
      this.$store.commit("showCart", true);
    },
    handleAlertClick() {
      this.$router.push({ path: "/professional-design-services" });
    },
    resetSearch() {
      this.$store.commit("setSearchPage", 1);
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    setBackgroundColor() {
      document.body.classList.add("bg-default");
    },
    removeBackgroundColor() {
      document.body.classList.remove("bg-default");
    },
    updateBackground() {
      if (!this.$route.meta.noBodyBackground) {
        this.setBackgroundColor();
      } else {
        this.removeBackgroundColor();
      }
    },
    handleScroll() {
      this.scrolled = window.scrollY > 100;
    },
    logout: function () {
      this.$store.dispatch("logoutRequest").then(() => {
        if (this.$route.path !== "/") {
          this.$router.push({ path: "/" });
        }
      });
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, false);
    this.isInstagram = navigator.userAgent.match(/instagram/i);
    // if (this.isLoggedIn) {
    //   this.$store.dispatch("getNotifications");
    //   this.notificationLoop = setInterval(() => {
    //     this.$store.dispatch("getNotifications");
    //   }, 60000);
    // }
    if (this.isLoggedIn) {
      this.$store.dispatch("getCart");
    }

    this.axios
      .get(`${apiBaseURL}/api/artv1.1/plan/getdesignservices`)
      .then((result) => {
        if (result.data.data.message === "Success") {
          this.typographyServices = result.data.data.services;
        }
      })
      .catch((error) => {
        /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
        console.error(error);
      });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, false);
    this.removeBackgroundColor();
  },
  beforeRouteEnter(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  watch: {
    $route(to, from) {
      const pageName = to.name.toUpperCase().replace(/\s+/g, "");

      if (this.$route.query.referral) {
        this.$store.commit("setReferral", this.$route.query.referral);
      }

      this.closeMenu();
      this.updateBackground();
    },
    showAddToCollectionModal(newValue, oldValue) {
      this.modals.addToCollection = newValue;
    },
    showCreateCollectionModal(newValue, oldValue) {
      this.modals.createCollection = newValue;
    },
    showEditCollectionModal(newValue, oldValue) {
      this.modals.editCollection = newValue;
    },
    // isLoggedIn(newValue, oldValue) {
    //   if (!newValue) {
    //     clearInterval(this.notificationLoop);
    //   }
    // },
    // isLoggedIn(newValue, oldValue) {
    //   if (!newValue) {
    //     clearInterval(this.cartLoop);
    //   }
    // },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.8;
.navbar-black {
  background-color: rgba(0, 0, 0, 0.9) !important;
}

.instagram-nav {
  top: 0 !important;
}

.navbar-main {
  margin-top: 30px;
  .nav-link {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .credits-link {
    cursor: default;
    pointer-events: none;
  }
}

// .discount-alert {
//   background: transparent;
//   position: fixed;
//   z-index: 101;
//   width: 100%;
//   height: 0;

//   a {
//     cursor: pointer;
//   }
// }

.discount-alert {
  position: fixed;
  z-index: 101;
  width: 100%;
  height: 30px;
  top: 0;
  font-size: 0.75rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0;
  border: none;
  box-shadow: none;
  background: black;

  &:hover,
  &:active,
  &:focus {
    border: none;
    color: white !important;
    transform: none;
    box-shadow: none;
    background: black !important;
  }

  a {
    cursor: pointer;
    width: 100%;
    height: 100%;
    display: inline;
    color: white;
    text-align: center;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 12px !important;
  }
}

@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}
.main-content {
  min-height: calc(100vh - 381px);
  margin-top: 30px;
}
.main-content .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-content .zoomOut {
  animation-name: zoomOut8;
}

@media (max-width: 1066px) {
  .navbar-horizontal,
  .dashboard-nav {
    .nav-link {
      padding-right: 0.25rem !important;
      padding-left: 0.25rem !important;
    }
    .navbar-brand {
      img {
        height: 40px;
      }
    }
  }
}

@media (max-width: 991.98px) {
  .navbar-horizontal,
  .dashboard-nav {
    &.navbar {
      padding: 0.75rem 1rem;
    }
    .navbar-nav {
      .nav-link {
        color: black !important;
      }
    }
  }
  .login-button {
    color: black !important;
    padding: 0.625rem 0;
    font-size: 0.825rem;
    margin-left: 0.25rem;
  }
  ul {
    &.navbar-nav {
      text-align: center;
    }
  }
}
</style>
